export const TEST_IDS = {
    SCALE_NAME_PREFIX: 'scale-name-',
  QUESTION_CONTAINER: 'question-container',
  QUESTION_TEXT: 'question-text',
  NEXT_BUTTON: 'next-button',
  PREV_BUTTON: 'prev-button',
  FINISH_BUTTON: 'finish-button',
  RESULTS_PAGE: 'results-page',
  LIKERT_CHOICE_PREFIX: 'likert-choice-',
  ACE_CHOICE_PREFIX: 'ace-choice-',
  SCALE_SCORE_PREFIX: 'scale-score-',
  START_BUTTON: 'start-button',
  DEMOGRAPHICS_FORM: 'demographics-form',
  SUBMIT_DEMOGRAPHICS_BUTTON: 'submit-demographics-button',
  AGE_INPUT: 'age-input',
  GENDER_SELECT: 'gender-select',
};
